export const faqs = [
  {
    question: '「色即是空」中的「色」指的是颜色吗？',
    answer: '不是的。在佛教术语中，「色」（rūpa）指的是一切物质现象，包括我们的身体和外部世界的所有有形之物。它比日常语言中「颜色」的含义要广泛得多。在五蕴中，「色蕴」涵盖了全部物质层面——地、水、火、风四大元素及其所造的一切。',
  },
  {
    question: '「空」是不是就是什么都没有的意思？',
    answer: '这是一个最常见的误解。佛教所说的「空」（śūnyatā）绝非虚无或什么都没有，而是指万物没有固定不变的自性（本质）。一切法都是因缘和合而生、因缘消散而灭。正如波浪有来有去，但水的本性不变。空性是「无自性」的意思，而不是「不存在」。',
  },
  {
    question: '如果一切都是空的，那修行还有什么意义？',
    answer: '恰恰相反，正因为一切是空的，修行才真正有意义。如果万物的本性是固定不变的，那么凡夫永远只能是凡夫，不可能成佛。正因为一切法都是空性的、无自性的，改变才是可能的，解脱才是可能的。龙树菩萨说：「以有空义故，一切法得成。」',
  },
  {
    question: '理解「色即是空」会不会让人变得消极？',
    answer: '这是一个需要厘清的问题。真正理解空性智慧，不仅不会让人消极，反而会让人更积极地面对生活。因为你不再被得失、成败所束缚，反而能以更清明、更自在的心态去行动。就像优秀的运动员在赛场上「忘我」的状态——不是消极放弃，而是放下了对结果的执著，反而发挥得更好。',
  },
  {
    question: '《心经》适合初学者阅读吗？',
    answer: '非常适合。《心经》全文仅二百六十字，是般若经典中最短的一篇，却是义理最深奥的。初学者可以从字面理解开始，逐步深入。建议先读几遍全文，熟悉文字，然后配合注释和解读来理解。重要的是，不要把《心经》仅仅当作知识来学习，而是将它作为一种观照生活的方式。',
  },
  {
    question: '如何将「色即是空」的智慧应用在日常生活中？',
    answer: '最简单的入手方法就是「观无常」。每当你执著于某件事物时，提醒自己：这一切都是因缘和合的暂时现象，不必过度执取。遇到不顺心的事时，告诉自己：这也会过去。遇到开心的事时，尽情享受但不贪恋。渐渐地，你会发现内心变得越来越自在。',
  },
  {
    question: '空性哲学与科学有冲突吗？',
    answer: '没有冲突。事实上，现代物理学的一些发现——比如量子力学中的波粒二象性、量子纠缠等——与佛教的空性观有奇妙的呼应。当然，科学和佛学在方法和目标上是不同的：科学探索物质世界的规律，佛学关注心灵的解脱。两者可以互补而非对立。',
  },
];

export const testimonials = [
  {
    name: '林静怡',
    role: '心理咨询师',
    content: '「色即是空」的智慧让我在工作中找到了新的视角。以前我总想把来访者的问题「修好」，现在学会了用空性的眼光去陪伴——不执著于结果，反而效果更好了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20soft%20natural%20studio%20lighting%2C%20simple%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '陈志远',
    role: '互联网创业者',
    content: '创业十年的起起伏伏，让我深刻体会到「一切皆空」的含义。成功时不必得意忘形，失败时不必灰心丧气。感谢这个平台，让我在焦虑时找到了内心的平静。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20professional%20portrait%2C%20warm%20and%20approachable%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '王诗涵',
    role: '大学教师',
    content: '作为一名哲学教师，我一直在寻找将深奥的空性哲学用通俗语言表达的方式。这里的内容深入浅出，既有学术深度又不失可读性，我已经推荐给了我的学生们。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20academic%20portrait%2C%20gentle%20smile%2C%20warm%20studio%20lighting%2C%20simple%20background%2C%20scholarly%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];